import { Flex, Grid, GridItem, Icon, Image } from '@chakra-ui/react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { PaymentMethod } from '~/lib/payment';
import { getGachaCarrierPaymentList } from '~/lib/utils/payment';
import { PaymentMethodVariables } from '~/types/payment';

type Props = {
  payment_methods: PaymentMethod[];
  selectedMethod: PaymentMethodVariables;
  onSelect: (method: PaymentMethodVariables) => void;
};

export const CarriersPaymentForm: React.FC<Props> = (props: Props) => {
  const paymentMethods = getGachaCarrierPaymentList(props.payment_methods);

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={3} w="full">
      {paymentMethods.map((method: PaymentMethod) => {
        return (
          <CarriersPaymentMethodRow
            key={method.id}
            method={method}
            selectedMethod={props.selectedMethod}
            onSelect={props.onSelect}
          />
        );
      })}
    </Grid>
  );
};

const CarriersPaymentMethodRow: React.FC<{
  method: PaymentMethod;
  selectedMethod: PaymentMethodVariables | null;
  onSelect: (value: string) => void;
}> = (props) => {
  const { method, selectedMethod, onSelect } = props;

  return (
    <GridItem key={method.id} onClick={() => onSelect(method.id)}>
      <Flex
        pt={4}
        pb={2}
        px={2}
        border={1}
        borderColor={selectedMethod === method.id ? 'primary' : 'white'}
        borderStyle="solid"
        rounded="md"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
        shadow="md"
        position="relative"
      >
        <Flex position="absolute" top={0} right={0} p={1}>
          <Icon
            as={AiFillCheckCircle}
            color={selectedMethod === method.id ? 'primary' : 'gray.300'}
            w={6}
            h={6}
          />
        </Flex>
        {method.icon_image ? (
          <Image src={method.icon_image} alt="icon" h={8} my={2} />
        ) : (
          <Icon
            as={method.icon}
            w="full"
            h={8}
            my={2}
            color={selectedMethod === method.id ? 'primary' : ''}
          />
        )}
      </Flex>
    </GridItem>
  );
};
